import React from 'react'
import NextLink from 'next/link'
import PropTypes from 'prop-types'
import { Typography, Row, Col } from 'antd'
import { unslugify } from 'shared/util'

export default function OtherCitiesList({ allCities }) {
  const { Title } = Typography
  return (
    <>
      <Row>
        <Col>
          <Title level={2}>Cities List for Stock Brokers</Title>
        </Col>
      </Row>
      <Row gutter={[16, 24]}>
        {allCities.map((cityObj, idx) => {
          const {
            attributes: { name: city, state },
          } = cityObj
          return (
            <Col className="gutter-row" xs={12} md={6} key={idx}>
              <NextLink
                key={idx}
                href="/brokers/[city]/[state]"
                as={`/brokers/${city}/${state}`}
              >
                {`${unslugify(city)}, ${unslugify(state)}`}
              </NextLink>
            </Col>
          )
        })}
      </Row>
    </>
  )
}

OtherCitiesList.propTypes = {
  allCities: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
}
